import { useEffect, useState } from 'react';

/**
 * Listens for the custom 'session-expiring' DOM event fired by api.js
 * 5 minutes before JWT expiry, and shows a persistent warning banner.
 */
export default function SessionWarning() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onExpiring = () => setShow(true);
    window.addEventListener('session-expiring', onExpiring);
    return () => window.removeEventListener('session-expiring', onExpiring);
  }, []);

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 99999,
      background: '#f59e0b', color: '#1c1917',
      padding: '10px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      fontSize: '0.875rem', fontWeight: 600,
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    }}>
      <span>
        ⚠️ Your session expires in 5 minutes. Save your work and
        {' '}
        <a
          href="/login"
          style={{ color: '#1c1917', textDecoration: 'underline', fontWeight: 700 }}
          onClick={() => { localStorage.removeItem('token'); }}
        >
          log in again
        </a>
        {' '}to stay signed in.
      </span>
      <button
        onClick={() => setShow(false)}
        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.1rem', color: '#1c1917', padding: '0 4px' }}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
